import _asyncToGenerator from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n4 = 0, F = function F() {}; return { s: F, n: function n() { return _n4 >= r.length ? { done: !0 } : { done: !1, value: r[_n4++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*!
 * storyblok-js-client v4.5.2
 * Universal JavaScript SDK for Storyblok's API
 * (c) 2020-2022 Stobylok Team
 */
import e from "axios";
function t(e) {
  return "number" == typeof e && e == e && e !== 1 / 0 && e !== -1 / 0;
}
function s(e, s, r) {
  if (!t(s)) throw new TypeError("Expected `limit` to be a finite number");
  if (!t(r)) throw new TypeError("Expected `interval` to be a finite number");
  var i = [],
    n = [],
    o = 0,
    _a = function a() {
      o++;
      var t = setTimeout(function () {
        o--, i.length > 0 && _a(), n = n.filter(function (e) {
          return e !== t;
        });
      }, r);
      n.indexOf(t) < 0 && n.push(t);
      var s = i.shift();
      s.resolve(e.apply(s.self, s.args));
    },
    l = function l() {
      var e = arguments,
        t = this;
      return new Promise(function (r, n) {
        i.push({
          resolve: r,
          reject: n,
          args: e,
          self: t
        }), o < s && _a();
      });
    };
  return l.abort = function () {
    n.forEach(clearTimeout), n = [], i.forEach(function (e) {
      e.reject(new throttle.AbortError());
    }), i.length = 0;
  }, l;
}
s.AbortError = function () {
  Error.call(this, "Throttled function aborted"), this.name = "AbortError";
};
var r = function r(e, t) {
  if (!e) return null;
  var s = {};
  for (var _r in e) {
    var _i = e[_r];
    t.indexOf(_r) > -1 && null !== _i && (s[_r] = _i);
  }
  return s;
};
var i = {
  nodes: {
    horizontal_rule: function horizontal_rule() {
      return {
        singleTag: "hr"
      };
    },
    blockquote: function blockquote() {
      return {
        tag: "blockquote"
      };
    },
    bullet_list: function bullet_list() {
      return {
        tag: "ul"
      };
    },
    code_block: function code_block(e) {
      return {
        tag: ["pre", {
          tag: "code",
          attrs: e.attrs
        }]
      };
    },
    hard_break: function hard_break() {
      return {
        singleTag: "br"
      };
    },
    heading: function heading(e) {
      return {
        tag: "h".concat(e.attrs.level)
      };
    },
    image: function image(e) {
      return {
        singleTag: [{
          tag: "img",
          attrs: r(e.attrs, ["src", "alt", "title"])
        }]
      };
    },
    list_item: function list_item() {
      return {
        tag: "li"
      };
    },
    ordered_list: function ordered_list() {
      return {
        tag: "ol"
      };
    },
    paragraph: function paragraph() {
      return {
        tag: "p"
      };
    }
  },
  marks: {
    bold: function bold() {
      return {
        tag: "b"
      };
    },
    strike: function strike() {
      return {
        tag: "strike"
      };
    },
    underline: function underline() {
      return {
        tag: "u"
      };
    },
    strong: function strong() {
      return {
        tag: "strong"
      };
    },
    code: function code() {
      return {
        tag: "code"
      };
    },
    italic: function italic() {
      return {
        tag: "i"
      };
    },
    link: function link(e) {
      var t = _objectSpread({}, e.attrs),
        _e$attrs$linktype = e.attrs.linktype,
        s = _e$attrs$linktype === void 0 ? "url" : _e$attrs$linktype;
      return "email" === s && (t.href = "mailto:".concat(t.href)), t.anchor && (t.href = "".concat(t.href, "#").concat(t.anchor), delete t.anchor), {
        tag: [{
          tag: "a",
          attrs: t
        }]
      };
    },
    styled: function styled(e) {
      return {
        tag: [{
          tag: "span",
          attrs: e.attrs
        }]
      };
    }
  }
};
var n = /*#__PURE__*/function () {
  function n(e) {
    _classCallCheck(this, n);
    e || (e = i), this.marks = e.marks || [], this.nodes = e.nodes || [];
  }
  return _createClass(n, [{
    key: "addNode",
    value: function addNode(e, t) {
      this.nodes[e] = t;
    }
  }, {
    key: "addMark",
    value: function addMark(e, t) {
      this.marks[e] = t;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (e.content && Array.isArray(e.content)) {
        var _t = "";
        return e.content.forEach(function (e) {
          _t += _this.renderNode(e);
        }), _t;
      }
      return console.warn("The render method must receive an object with a content field, which is an array"), "";
    }
  }, {
    key: "renderNode",
    value: function renderNode(e) {
      var _this2 = this;
      var t = [];
      e.marks && e.marks.forEach(function (e) {
        var s = _this2.getMatchingMark(e);
        s && t.push(_this2.renderOpeningTag(s.tag));
      });
      var s = this.getMatchingNode(e);
      return s && s.tag && t.push(this.renderOpeningTag(s.tag)), e.content ? e.content.forEach(function (e) {
        t.push(_this2.renderNode(e));
      }) : e.text ? t.push(function (e) {
        var t = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
          },
          s = /[&<>"']/g,
          r = RegExp(s.source);
        return e && r.test(e) ? e.replace(s, function (e) {
          return t[e];
        }) : e;
      }(e.text)) : s && s.singleTag ? t.push(this.renderTag(s.singleTag, " /")) : s && s.html && t.push(s.html), s && s.tag && t.push(this.renderClosingTag(s.tag)), e.marks && e.marks.slice(0).reverse().forEach(function (e) {
        var s = _this2.getMatchingMark(e);
        s && t.push(_this2.renderClosingTag(s.tag));
      }), t.join("");
    }
  }, {
    key: "renderTag",
    value: function renderTag(e, t) {
      if (e.constructor === String) return "<".concat(e).concat(t, ">");
      return e.map(function (e) {
        if (e.constructor === String) return "<".concat(e).concat(t, ">");
        {
          var _s = "<".concat(e.tag);
          if (e.attrs) for (var _t2 in e.attrs) {
            var _r2 = e.attrs[_t2];
            null !== _r2 && (_s += " ".concat(_t2, "=\"").concat(_r2, "\""));
          }
          return "".concat(_s).concat(t, ">");
        }
      }).join("");
    }
  }, {
    key: "renderOpeningTag",
    value: function renderOpeningTag(e) {
      return this.renderTag(e, "");
    }
  }, {
    key: "renderClosingTag",
    value: function renderClosingTag(e) {
      if (e.constructor === String) return "</".concat(e, ">");
      return e.slice(0).reverse().map(function (e) {
        return e.constructor === String ? "</".concat(e, ">") : "</".concat(e.tag, ">");
      }).join("");
    }
  }, {
    key: "getMatchingNode",
    value: function getMatchingNode(e) {
      if ("function" == typeof this.nodes[e.type]) return this.nodes[e.type](e);
    }
  }, {
    key: "getMatchingMark",
    value: function getMatchingMark(e) {
      if ("function" == typeof this.marks[e.type]) return this.marks[e.type](e);
    }
  }]);
}();
var o = function o() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
    var s = Math.abs(t - e) || 0,
      r = e < t ? 1 : -1;
    return function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return _toConsumableArray(Array(e)).map(t);
    }(s, function (t, s) {
      return s * r + e;
    });
  },
  _a2 = function a(e, t, s) {
    var r = [];
    for (var _i2 in e) {
      if (!Object.prototype.hasOwnProperty.call(e, _i2)) continue;
      var _n = e[_i2],
        _o = s ? "" : encodeURIComponent(_i2);
      var _l = void 0;
      _l = "object" == typeof _n ? _a2(_n, t ? t + encodeURIComponent("[" + _o + "]") : _o, Array.isArray(_n)) : (t ? t + encodeURIComponent("[" + _o + "]") : _o) + "=" + encodeURIComponent(_n), r.push(_l);
    }
    return r.join("&");
  };
var l = {},
  c = {};
var h = /*#__PURE__*/function () {
  function h(t, r) {
    _classCallCheck(this, h);
    if (!r) {
      var _e = t.region ? "-".concat(t.region) : "",
        _s2 = !1 === t.https ? "http" : "https";
      r = void 0 === t.oauthToken ? "".concat(_s2, "://api").concat(_e, ".storyblok.com/v2") : "".concat(_s2, "://api").concat(_e, ".storyblok.com/v1");
    }
    var i = Object.assign({}, t.headers),
      o = 5;
    void 0 !== t.oauthToken && (i.Authorization = t.oauthToken, o = 3), void 0 !== t.rateLimit && (o = t.rateLimit), this.richTextResolver = new n(t.richTextSchema), "function" == typeof t.componentResolver && this.setComponentResolver(t.componentResolver), this.maxRetries = t.maxRetries || 5, this.throttle = s(this.throttledRequest, o, 1e3), this.accessToken = t.accessToken, this.relations = {}, this.links = {}, this.cache = t.cache || {
      clear: "manual"
    }, this.client = e.create({
      baseURL: r,
      timeout: t.timeout || 0,
      headers: i,
      proxy: t.proxy || !1
    }), t.responseInterceptor && this.client.interceptors.response.use(function (e) {
      return t.responseInterceptor(e);
    }), this.resolveNestedRelations = t.resolveNestedRelations || !0;
  }
  return _createClass(h, [{
    key: "setComponentResolver",
    value: function setComponentResolver(e) {
      this.richTextResolver.addNode("blok", function (t) {
        var s = "";
        return t.attrs.body.forEach(function (t) {
          s += e(t.component, t);
        }), {
          html: s
        };
      });
    }
  }, {
    key: "parseParams",
    value: function parseParams() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return e.version || (e.version = "published"), e.token || (e.token = this.getToken()), e.cv || (e.cv = c[e.token]), Array.isArray(e.resolve_relations) && (e.resolve_relations = e.resolve_relations.join(",")), e;
    }
  }, {
    key: "factoryParamOptions",
    value: function factoryParamOptions(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return e.indexOf("/cdn/") > -1;
      }(e) ? this.parseParams(t) : t;
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(e, t, s, r) {
      var i = this.factoryParamOptions(e, function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        return _objectSpread(_objectSpread({}, e), {}, {
          per_page: t,
          page: s
        });
      }(t, s, r));
      return this.cacheResponse(e, i);
    }
  }, {
    key: "get",
    value: function get(e, t) {
      var s = "/".concat(e);
      var r = this.factoryParamOptions(s, t);
      return this.cacheResponse(s, r);
    }
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var _this3 = this;
        var t,
          s,
          r,
          i,
          n,
          a,
          l,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              t = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              s = _args3.length > 2 ? _args3[2] : undefined;
              r = t.per_page || 25, i = "/".concat(e), n = i.split("/");
              s = s || n[n.length - 1];
              _context3.next = 6;
              return this.makeRequest(i, t, r, 1);
            case 6:
              a = _context3.sent;
              l = a.total ? Math.ceil(a.total / r) : 1;
              _context3.t0 = function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var t = arguments.length > 1 ? arguments[1] : undefined;
                return e.map(t).reduce(function (e, t) {
                  return [].concat(_toConsumableArray(e), _toConsumableArray(t));
                }, []);
              };
              _context3.t1 = [a];
              _context3.t2 = _toConsumableArray;
              _context3.next = 13;
              return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var e,
                  t,
                  _args = arguments;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      e = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
                      t = _args.length > 1 ? _args[1] : undefined;
                      return _context.abrupt("return", Promise.all(e.map(t)));
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }))(o(1, l), /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", _this3.makeRequest(i, t, r, e + 1));
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 13:
              _context3.t3 = _context3.sent;
              _context3.t4 = (0, _context3.t2)(_context3.t3);
              _context3.t5 = _context3.t1.concat.call(_context3.t1, _context3.t4);
              _context3.t6 = function (e) {
                return Object.values(e.data[s]);
              };
              return _context3.abrupt("return", (0, _context3.t0)(_context3.t5, _context3.t6));
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAll(_x) {
        return _getAll.apply(this, arguments);
      }
      return getAll;
    }()
  }, {
    key: "post",
    value: function post(e, t) {
      var s = "/".concat(e);
      return this.throttle("post", s, t);
    }
  }, {
    key: "put",
    value: function put(e, t) {
      var s = "/".concat(e);
      return this.throttle("put", s, t);
    }
  }, {
    key: "delete",
    value: function _delete(e, t) {
      var s = "/".concat(e);
      return this.throttle("delete", s, t);
    }
  }, {
    key: "getStories",
    value: function getStories(e) {
      return this.get("cdn/stories", e);
    }
  }, {
    key: "getStory",
    value: function getStory(e, t) {
      return this.get("cdn/stories/".concat(e), t);
    }
  }, {
    key: "setToken",
    value: function setToken(e) {
      this.accessToken = e;
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.accessToken;
    }
  }, {
    key: "_cleanCopy",
    value: function _cleanCopy(e) {
      return JSON.parse(JSON.stringify(e));
    }
  }, {
    key: "_insertLinks",
    value: function _insertLinks(e, t) {
      var s = e[t];
      s && "multilink" == s.fieldtype && "story" == s.linktype && "string" == typeof s.id && this.links[s.id] ? s.story = this._cleanCopy(this.links[s.id]) : s && "story" === s.linktype && "string" == typeof s.uuid && this.links[s.uuid] && (s.story = this._cleanCopy(this.links[s.uuid]));
    }
  }, {
    key: "_insertRelations",
    value: function _insertRelations(e, t, s) {
      var _this4 = this;
      if (s.indexOf(e.component + "." + t) > -1) if ("string" == typeof e[t]) this.relations[e[t]] && (e[t] = this._cleanCopy(this.relations[e[t]]));else if (e[t].constructor === Array) {
        var _s3 = [];
        e[t].forEach(function (e) {
          _this4.relations[e] && _s3.push(_this4._cleanCopy(_this4.relations[e]));
        }), e[t] = _s3;
      }
    }
  }, {
    key: "_insertAssetsRelations",
    value: function _insertAssetsRelations(e, t) {
      t.forEach(function (t) {
        e.id === t.id && (e.original = t, e.original.filename = e.filename, e.original.filename = e.original.filename.includes("https://s3.amazonaws.com/") ? e.original.filename : e.original.filename.replace("https://", "https://s3.amazonaws.com/"), delete e.original.s3_filename);
      });
    }
  }, {
    key: "iterateTree",
    value: function iterateTree(e, t) {
      var _this5 = this;
      var _s4 = function s(e) {
        if (null != e) if (e.constructor === Array) for (var _t3 = 0; _t3 < e.length; _t3++) _s4(e[_t3]);else if (e.constructor === Object) {
          if (e._stopResolving) return;
          for (var _r3 in e) e.component && e._uid || "link" === e.type ? (_this5._insertRelations(e, _r3, t), _this5._insertLinks(e, _r3)) : "id" in e && "asset" === e.fieldtype && _this5._insertAssetsRelations(e, t), _s4(e[_r3]);
        }
      };
      _s4(e.content);
    }
  }, {
    key: "resolveLinks",
    value: function () {
      var _resolveLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
        var _this6 = this;
        var s, _r4, _i3, _n2, _t4, _s5, _e2;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              s = [];
              if (!e.link_uuids) {
                _context4.next = 16;
                break;
              }
              _r4 = e.link_uuids.length;
              _i3 = [];
              _n2 = 50;
              for (_t4 = 0; _t4 < _r4; _t4 += _n2) {
                _s5 = Math.min(_r4, _t4 + _n2);
                _i3.push(e.link_uuids.slice(_t4, _s5));
              }
              _e2 = 0;
            case 7:
              if (!(_e2 < _i3.length)) {
                _context4.next = 14;
                break;
              }
              _context4.next = 10;
              return this.getStories({
                per_page: _n2,
                language: t.language,
                version: t.version,
                by_uuids: _i3[_e2].join(",")
              });
            case 10:
              _context4.sent.data.stories.forEach(function (e) {
                s.push(e);
              });
            case 11:
              _e2++;
              _context4.next = 7;
              break;
            case 14:
              _context4.next = 17;
              break;
            case 16:
              s = e.links;
            case 17:
              s.forEach(function (e) {
                _this6.links[e.uuid] = _objectSpread(_objectSpread({}, e), {}, {
                  _stopResolving: !0
                });
              });
            case 18:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function resolveLinks(_x3, _x4) {
        return _resolveLinks.apply(this, arguments);
      }
      return resolveLinks;
    }()
  }, {
    key: "resolveRelations",
    value: function () {
      var _resolveRelations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
        var _this7 = this;
        var s, _r5, _i4, _n3, _t5, _s6, _e3;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              s = [];
              if (!e.rel_uuids) {
                _context5.next = 16;
                break;
              }
              _r5 = e.rel_uuids.length;
              _i4 = [];
              _n3 = 50;
              for (_t5 = 0; _t5 < _r5; _t5 += _n3) {
                _s6 = Math.min(_r5, _t5 + _n3);
                _i4.push(e.rel_uuids.slice(_t5, _s6));
              }
              _e3 = 0;
            case 7:
              if (!(_e3 < _i4.length)) {
                _context5.next = 14;
                break;
              }
              _context5.next = 10;
              return this.getStories({
                per_page: _n3,
                language: t.language,
                version: t.version,
                by_uuids: _i4[_e3].join(",")
              });
            case 10:
              _context5.sent.data.stories.forEach(function (e) {
                s.push(e);
              });
            case 11:
              _e3++;
              _context5.next = 7;
              break;
            case 14:
              _context5.next = 17;
              break;
            case 16:
              s = e.rels;
            case 17:
              s.forEach(function (e) {
                _this7.relations[e.uuid] = _objectSpread(_objectSpread({}, e), {}, {
                  _stopResolving: !0
                });
              });
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function resolveRelations(_x5, _x6) {
        return _resolveRelations.apply(this, arguments);
      }
      return resolveRelations;
    }()
  }, {
    key: "resolveStories",
    value: function () {
      var _resolveStories = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, t) {
        var _this8 = this;
        var s, _e4;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              s = [];
              _context6.t0 = void 0 !== t.resolve_relations && t.resolve_relations.length > 0 && (e.rels || e.rel_uuids);
              if (!_context6.t0) {
                _context6.next = 6;
                break;
              }
              s = t.resolve_relations.split(",");
              _context6.next = 6;
              return this.resolveRelations(e, t);
            case 6:
              _context6.t1 = ["1", "story", "url"].indexOf(t.resolve_links) > -1 && (e.links || e.link_uuids);
              if (!_context6.t1) {
                _context6.next = 10;
                break;
              }
              _context6.next = 10;
              return this.resolveLinks(e, t);
            case 10:
              if (!this.resolveNestedRelations) {
                _context6.next = 12;
                break;
              }
              for (_e4 in this.relations) this.iterateTree(this.relations[_e4], s);
            case 12:
              e.story ? this.iterateTree(e.story, s) : e.stories.forEach(function (e) {
                _this8.iterateTree(e, s);
              });
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function resolveStories(_x7, _x8) {
        return _resolveStories.apply(this, arguments);
      }
      return resolveStories;
    }()
  }, {
    key: "resolveAssetsRelations",
    value: function resolveAssetsRelations(e) {
      var t = e.assets,
        s = e.stories,
        r = e.story;
      if (s) {
        var _iterator = _createForOfIteratorHelper(s),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e5 = _step.value;
            this.iterateTree(_e5, t);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        if (!r) return e;
        this.iterateTree(r, t);
      }
    }
  }, {
    key: "cacheResponse",
    value: function cacheResponse(e, t, s) {
      var _this9 = this;
      return void 0 === s && (s = 0), new Promise(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(r, i) {
          var n, o, _e6, _s7, _l2, l;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                n = _a2({
                  url: e,
                  params: t
                }), o = _this9.cacheProvider();
                _context7.t0 = "auto" === _this9.cache.clear && "draft" === t.version;
                if (!_context7.t0) {
                  _context7.next = 5;
                  break;
                }
                _context7.next = 5;
                return _this9.flushCache();
              case 5:
                if (!("published" === t.version && "/cdn/spaces/me" != e)) {
                  _context7.next = 11;
                  break;
                }
                _context7.next = 8;
                return o.get(n);
              case 8:
                _e6 = _context7.sent;
                if (!_e6) {
                  _context7.next = 11;
                  break;
                }
                return _context7.abrupt("return", r(_e6));
              case 11:
                _context7.prev = 11;
                _context7.next = 14;
                return _this9.throttle("get", e, {
                  params: t,
                  paramsSerializer: function paramsSerializer(e) {
                    return _a2(e);
                  }
                });
              case 14:
                _s7 = _context7.sent;
                _l2 = {
                  data: _s7.data,
                  headers: _s7.headers
                };
                if (!(_l2.data.assets && _l2.data.assets.length && _this9.resolveAssetsRelations(_l2.data), _l2 = Object.assign({}, _l2, {
                  perPage: _s7.headers["per-page"] ? parseInt(_s7.headers["per-page"]) : 0,
                  total: _s7.headers["per-page"] ? parseInt(_s7.headers.total) : 0
                }), 200 != _s7.status)) {
                  _context7.next = 18;
                  break;
                }
                return _context7.abrupt("return", i(_s7));
              case 18:
                _context7.t1 = _l2.data.story || _l2.data.stories;
                if (!_context7.t1) {
                  _context7.next = 22;
                  break;
                }
                _context7.next = 22;
                return _this9.resolveStories(_l2.data, t);
              case 22:
                "published" === t.version && "/cdn/spaces/me" != e && o.set(n, _l2);
                _l2.data.cv && ("draft" == t.version && c[t.token] != _l2.data.cv && _this9.flushCache(), c[t.token] = _l2.data.cv);
                r(_l2);
                _context7.next = 35;
                break;
              case 27:
                _context7.prev = 27;
                _context7.t2 = _context7["catch"](11);
                if (!(_context7.t2.response && 429 === _context7.t2.response.status && (s += 1) < _this9.maxRetries)) {
                  _context7.next = 34;
                  break;
                }
                console.log("Hit rate limit. Retrying in ".concat(s, " seconds."));
                _context7.next = 33;
                return l = 1e3 * s, new Promise(function (e) {
                  return setTimeout(e, l);
                });
              case 33:
                return _context7.abrupt("return", _this9.cacheResponse(e, t, s).then(r).catch(i));
              case 34:
                i(_context7.t2);
              case 35:
              case "end":
                return _context7.stop();
            }
          }, _callee7, null, [[11, 27]]);
        }));
        return function (_x9, _x0) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "throttledRequest",
    value: function throttledRequest(e, t, s) {
      return this.client[e](t, s);
    }
  }, {
    key: "cacheVersions",
    value: function cacheVersions() {
      return c;
    }
  }, {
    key: "cacheVersion",
    value: function cacheVersion() {
      return c[this.accessToken];
    }
  }, {
    key: "setCacheVersion",
    value: function setCacheVersion(e) {
      this.accessToken && (c[this.accessToken] = e);
    }
  }, {
    key: "cacheProvider",
    value: function cacheProvider() {
      return "memory" === this.cache.type ? {
        get: function get(e) {
          return l[e];
        },
        getAll: function getAll() {
          return l;
        },
        set: function set(e, t) {
          l[e] = t;
        },
        flush: function flush() {
          l = {};
        }
      } : {
        get: function get() {},
        getAll: function getAll() {},
        set: function set() {},
        flush: function flush() {}
      };
    }
  }, {
    key: "flushCache",
    value: function () {
      var _flushCache = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.cacheProvider().flush();
            case 2:
              return _context8.abrupt("return", this);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function flushCache() {
        return _flushCache.apply(this, arguments);
      }
      return flushCache;
    }()
  }]);
}();
export { h as default };